import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import Folder from 'modules/documents/store/models/Folder'

export class Folders extends Collection<Folder> {
  constructor(data: any = []) {
    super(data)
    makeObservable(this, {
      payrollExportsFolder: computed
    })
  }

  get cacheKey(): string {
    return 'folders'
  }

  get indexes() {
    return ['url', 'is_employee']
  }

  get payrollExportsFolder(): Folder | null | undefined {
    return this.find({
      type: 'payroll_exports'
    })
  }

  model() {
    return Folder
  }
}

const singleton: Folders = new Folders()

export default singleton
